<template>
  <div style="width:100%">
    <v-dialog
          v-model="editModal"
          :persistent="true"
          max-width="500px"
        >
          <v-card v-if="selectedItem">
            <v-app-bar
                  dark
                  color="blue"
                >
                  <v-toolbar-title>{{ selectedItem.name }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    style="float:right"
                    @click="closeEditClassroomDialog"
                  >
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-app-bar>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-select
                      v-model="editedItem.type"
                      :items="['Class','Club','Team','Other']"
                      label="Type"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.name"
                      label="Name"
                    />
                  </v-flex>
                  <v-flex
                    xs6
                  >
                    <v-text-field
                      v-model="editedItem.section"
                      label="Section"
                    />
                  </v-flex>

                  <v-flex
                    xs6
                  >
                    <v-text-field
                      v-model="editedItem.room"
                      label="Room"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-menu
                      v-model="dateRanageMenu"
                      :close-on-content-click="false"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dateRangeText"
                          label="Start / End Dates"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        no-title
                        range
                        v-model="dateRangeDates"
                      />
                    </v-menu>
                    <v-btn x-small
                      v-on:click="clearDateRange"
                    >clear date range</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions style="padding-right:50px">
              <v-spacer />
              <v-btn
                :loading="loadingActivateAccountButton"
                text
                @click="deactivateItem"
              >
                deactivate
              </v-btn>
              <v-btn
              v-show="editedItem.deactivated_date"
              color="primary"
              :loading="loadingActivateAccountButton"
                @click="activateItem"
              >
                activate
              </v-btn>
              <v-btn
                text
                @click="closeEditClassroomDialog"
              >
                close
              </v-btn>
              <v-btn
                :loading="saving"
                text
                @click="saveClass"
              >
                save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    <v-layout>

    </v-layout>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-toolbar flat>
              <v-text-field
                v-model="table.search"
                append-icon="mdi-search"
                label="Search Course / Name / Department / Teacher"
                single-line
                hide-details
              ></v-text-field>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    text
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ items.length }} {{ params.status }} Courses
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="params.status = 'ACTIVE'; search()">
                    <v-list-item-title>Active Courses</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="params.status = 'ALL'; search()">
                    <v-list-item-title>All Courses</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
          </v-toolbar>
            <v-data-table
              :headers="table.headers"
              :items="items"
              :dense="true"
              :search="table.search"
              :sort-by="['when_entered']"
              :sort-desc="true"
              :hide-default-footer="true"
              :disable-pagination="true"
              height="75vh"
            >
            <template v-slot:item="props">
              <tr>
                <td style="font-size:.8em" class="text-xs">
                  <router-link :to="'/class/'+props.item.uid">{{ props.item.uid }}</router-link>
                </td>
                <td style="font-size:.8em" class="text-xs">
                  {{ props.item.name }}
                </td>
                <td  style="font-size:.8em" class="text-xs">
                  {{ props.item.department }}
                </td>
                <td  style="font-size:.8em" class="text-xs">
                  <div v-for="teacher in props.item.teachers.split(',')" :key="teacher">
                    {{ teacher.split("@")[0] }}
                  </div>
                </td>
                <td  style="font-size:.8em" class="text-xs">
                  {{ props.item.num_students }}
                </td>
                <td class="text-xs-center">
                  <v-btn icon x-small
                    @click="openEditClassroomDialog(props.item)"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </td>
              </tr>
              </template>
            </v-data-table>
          </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
const api = require('../apiFunctions.js')
const fb = require('../firebaseConfig.js')
function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export default {
  data: () => ({
    user: fb.session.user,
    userKey: 'all',
    params: {
    },
    editModal: false,
    dateRangeDates: [],
    dateRanageMenu: false,
    selectedItem: null,
    editedItem: null,
    saving: false,
    loadingActivateAccountButton: false,
    items: [],
    table: {
      search: '',
      headers: [
        { text: 'Course', value: 'uid' },
        { text: 'Name', value: 'name' },
        { text: 'Department', value: 'department' },
        { text: 'Teachers', value: 'teachers' },
        { text: 'Students', value: 'num_students' },
        { text: '', value: '' }
      ]
    }
  }),
  watch: {
    '$route' (to, from) {
      console.log(to, from) // react to route changes...
      this.checkRoutingParams()
    }
  },
  computed: {
    dateRangeText () {
      return this.dateRangeDates.join(' ~ ')
    },
  },
  mounted () {
    console.log('mounted')
    this.checkRoutingParams()
  },
  methods: {
    openEditClassroomDialog: function (item) {
      this.selectedItem = item
      this.editedItem = Object.assign({}, item)
      this.editModal = true
    },
    closeEditClassroomDialog: function (item) {
      this.selectedItem = null
      this.editedItem = null
      this.editModal = false
    },
    clearDateRange: function () {
      this.dateRangeDates = []
    },
    checkRoutingParams: function () {
      console.log(this.$route)
      let params = this.$route.params
      let query = this.$route.query
      this.params = {}
      Object.assign(this.params, params)
      Object.assign(this.params, query)
      this.search()
    },
    viewStudents: function (classroom) {
      api.get('getClassroomStudents', {courseId: classroom.id}, (data) => {
        console.log(data)
      })
    },
    activateItem: function () {

    },
    deactivateItem: function () {

    },
    saveClass: function () {
      var self = this
      api.post('updateClassroom', this.editedItem, (data) => {
        console.log(data)
        self.selectedItem = Object.assign( self.selectedItem, this.editedItem)
        self.editModal = false
      })
    },
    syncClasses: async function () {
      var self = this
      for (var i = 0 ; i < self.items.length; i++) {
        if ( !self.items[i].teachers) {
          await sleep(5000);
          console.log(self.items[i])
          api.get('syncClasses', {courseId: self.items[i].id}, (data) => {
          })
        } else {
          console.log( "skipping " + self.items[i].id)
        }
      }
    },
    syncClassroom: function (classroom) {
      api.get('syncClasses', {courseId: classroom.id}, (data) => {

      })
    },
    search: function () {
      var self = this
      console.log(this.params)
      this.params.userKey = this.userKey
      api.classes.get(this.params, (data) => {
        console.log(data)
        self.items = data
      })
    }
  }
}
</script>
